import { useQuery } from '@tanstack/react-query';
import { adminApi } from '../api/adminApi';
import { adminKeys } from '../api/adminQueryKeys';
export function useAdminStats() {
    return useQuery({
        queryKey: adminKeys.stats(),
        queryFn: adminApi.getStats,
    });
}
